import { Component } from "@angular/core";

@Component({
  selector: "cla-coverage-policy-container-ghost-loader",
  templateUrl: "./policy-container-ghost-loader.component.html",
  styleUrls: ["./policy-container.component.scss"],
  standalone: false,
})
export class PolicyContainerGhostLoaderComponent {}
